import { render, staticRenderFns } from "./CategoryProperties.vue?vue&type=template&id=73aa38a8&"
import script from "./CategoryProperties.vue?vue&type=script&lang=js&"
export * from "./CategoryProperties.vue?vue&type=script&lang=js&"
import style0 from "./CategoryProperties.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports